export default __webpack_public_path__ + "static/media/skyship18.9d542cb1.png";